import React from 'react';
import './listaprogramacao.css';
import {useState, useEffect} from 'react';
import api from '../../services/api.js';
import DataTable from 'react-data-table-component';
import ListaExecucao from "../ListaExecucao/listaexecucao.jsx" 
import { Link  } from "react-router-dom";

function ListaProgramacao(){

    let [dados,setdados] = useState([])

    const colunas = [
        { name:'',
        selector :row => row.IdExec, 
        width: "0px", 
        },
        { name:'Proposta',
          selector :row => row.IdProcesso, 
          sortable:true,
          width: "110px", 
        },
        {name:'Nº O.S.',
          selector :row => row.NumOrdem,
          sortable:true,
          width: "90px",
         },
        { name:'Data',
            selector :row => row.Data,
            sortable:true,
            width: "130px", 
          },
        {name:'Horário',
          selector :row => row.Horario,
          width: "120px", 
        },
      { name:'Tipo de Atendimento',
      selector :row => row.NomeAtendimento,
      sortable:true,
      width: "500px", },

            {
            name:'Veja como foi ',
            center:true,
             cell:(row) =><>
                    <Link to={'/ListaExecucao/'+ row.IdExec.toString()}  ><i className="fas fa-edit icone-acao"></i></Link>
            </>

          }]

     const paginationOptions={
        rowsPerPageText: 'Registros por página',
        rangeSeparatorText : 'de',
        selectAllRowsItem : true,
        selectAllRowsItemText :'Todos',
     } 
    async function CarregaPontos()
    {

        const user = localStorage.getItem("IdUsuario");
        
        const resultado = await api.get('/Programacao/?p='+user);
        setdados(resultado.data)   
      
         

    }

   
    useEffect(()=>{
          CarregaPontos()
    },[]
    );

    return (<>
            <DataTable className='tabela'
            columns= {colunas} 
            data={dados}
            pagination={true}
            paginationComponentOptions={paginationOptions}
            noDataComponent={"Nenhum registro encontrado !"}
            fixedHeader={true}
                />  
                  </>
        );

}

export default ListaProgramacao;